import {
  INIT,
  SET_STEPS,
  SET_STEP,
  CUSTOMER_DATA,
  ADVERTISING,
} from 'redux/actions/steps';
import Steps from 'redux/models/Steps';

let steps = new Steps();

export default (state = {}, action) => {
  switch (action.type) {
    case INIT:
      steps.init();
      break;

    case SET_STEP:
      steps.setStep(action.step);
      break;

    case SET_STEPS:
      steps.setSteps(action.accounts, action.account);
      break;

    case CUSTOMER_DATA:
      steps.addCrm(action.crm);
      break;

    case ADVERTISING:
      steps.addAdvertising(action.ad);
      break;

    default:
      return state;
  }

  return Object.assign({}, state, steps);
};



// WEBPACK FOOTER //
// ./src/redux/reducers/steps.js